import { useState } from 'react';
import { FiShare2 } from 'react-icons/fi';

const shareData = {
  title: 'Snowbird Showdown',
  text: 'Start the year on the grass. January 1 + 2, 2027 in Tucson, Arizona.',
  url: 'https://grassvb.com/',
};

export default function ShareWebsite() {
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const [manualCopy, setManualCopy] = useState(false);

  async function share() {
    setBusy(true);
    setMessage('');
    setManualCopy(false);
    try {
      if (navigator.share) {
        try {
          await navigator.share(shareData);
          return;
        } catch (error) {
          if (error.name === 'AbortError') return;
        }
      }
      try {
        await navigator.clipboard.writeText(shareData.url);
        setMessage('Link copied. Share it with your team!');
      } catch {
        setManualCopy(true);
        setMessage('Select and copy the link below.');
      }
    } finally {
      setBusy(false);
    }
  }

  return <div className="sb-mobile-share">
    <button type="button" className="sb-share-button" onClick={share} disabled={busy}>
      <FiShare2 aria-hidden="true" /> Share this event
    </button>
    <p className="sb-share-status" role="status">{message}</p>
    {manualCopy && <input aria-label="Website link to copy" readOnly value={shareData.url} onFocus={event => event.target.select()} />}
  </div>;
}
